export enum ConnectionStatus {
    Connected = "normal",
    Disconnected = "error",
  }
